import React from 'react';
import { ClockIcon, AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  label: string;
  note?: string;
  progress?: number;
}
export function Countdown({
  label,
  note,
  progress
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    unit: 'hs'
  }, {
    value: minutes,
    unit: 'min'
  }, {
    value: seconds,
    unit: 'seg'
  }];
  return <div className="rounded-2xl border border-ink-700 bg-ink-900 p-6 text-center sm:p-8" data-id="element-56" data-mp="3h1ie7uqc572n">
      <p className="flex items-center justify-center gap-2 font-display text-[11px] font-700 uppercase tracking-[0.24em] text-gold" data-id="element-57" data-mp="323yd4ywk7w1r">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-58" data-mp="373kpz78h7aa1" />
        {label}
      </p>

      <div className="mt-5 flex items-center justify-center gap-2 sm:gap-3" data-id="element-59" data-mp="10c3d5gjo1fzd">
        {units.map((item, index) => <React.Fragment key={item.unit} data-id="element-60" data-mp="15adde5k8z6ru" data-mpi={index}>
            <div className="min-w-[72px] rounded-lg bg-ink-950 px-3 py-3 sm:min-w-[92px]" data-id="element-61" data-mp="15928u3iz9uzo">
              <span className="block font-display text-3xl font-900 tabular-nums text-white sm:text-4xl" data-id="element-62" data-mp="xz3ly0ixv29u">
                {item.value}
              </span>
              <span className="mt-1 block text-[11px] uppercase tracking-widest text-slate-500" data-id="element-63" data-mp="17py8l603k3vt">
                {item.unit}
              </span>
            </div>
            {index < units.length - 1 && <span aria-hidden="true" className="font-display text-2xl text-ink-600" data-id="element-64" data-mp="f1iwosc9i1op">
                :
              </span>}
          </React.Fragment>)}
      </div>

      {note && <p className="mt-5 flex items-center justify-center gap-2 text-sm text-slate-400" style={{
      fontSize: "20px"
    }} data-id="element-65" data-mp="o30lr07nddpj">
          <AlertTriangleIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-66" data-mp="k15i3p28uo8l" />
          {note}
        </p>}

      {typeof progress === 'number' && <div className="mx-auto mt-6 max-w-md text-left" data-id="element-67" data-mp="1zk8pdjagypsn">
          <div className="flex items-center justify-between text-xs text-slate-400" data-id="element-68" data-mp="1vfisps7zl76o">
            <span data-id="element-69" data-mp="s66cdjsegq9b">Cupos al precio de lanzamiento</span>
            <span className="font-600 text-white" data-id="element-70" data-mp="s7r7baimmb7p">{progress}% tomados</span>
          </div>
          <div className="mt-2 h-2 overflow-hidden rounded-full bg-ink-950" role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos al precio de lanzamiento" data-id="element-71" data-mp="x2ws260alju7">
            <div className="h-full rounded-full bg-alert" style={{
          width: `${progress}%`
        }} data-id="element-72" data-mp="163bpu4ug0rel" />
          </div>
        </div>}
    </div>;
}